import { motion } from "framer-motion";

const categories = [
  { key: "necessary", label: "Necessari", locked: true,
    desc: "Indispensabili per il funzionamento del sito e per l'invio della richiesta di accesso. Sempre attivi." },
  { key: "analytics", label: "Statistiche",
    desc: "Ci aiutano a capire, in forma aggregata, come viene utilizzata la landing." },
  { key: "marketing", label: "Marketing",
    desc: "Meta Pixel: misura le campagne pubblicitarie e le conversioni (PageView, ViewContent, Contact, Lead)." },
];

const Toggle = ({ on, locked, onChange, testid }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    disabled={locked}
    data-testid={testid}
    onClick={onChange}
    className={`relative w-11 h-6 shrink-0 rounded-full transition-colors duration-300 ${on ? "bg-goldtan" : "bg-ivory/20"} ${locked ? "opacity-60 cursor-not-allowed" : ""}`}
  >
    <span className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-ivory transition-transform duration-300 ${on ? "translate-x-5" : ""}`} />
  </button>
);

export const CookiePreferencesPanel = ({ prefs, onToggle }) => (
  <motion.div
    data-testid="cookie-preferences-panel"
    initial={{ height: 0, opacity: 0 }}
    animate={{ height: "auto", opacity: 1 }}
    exit={{ height: 0, opacity: 0 }}
    transition={{ duration: 0.35 }}
    className="overflow-hidden"
  >
    <ul className="mt-5 divide-y divide-ivory/10 border-y border-ivory/10">
      {categories.map((c) => (
        <li key={c.key} className="flex items-start justify-between gap-4 py-4">
          <div>
            <p className="font-sans-ui text-[11px] tracking-mega text-ivory">{c.label.toUpperCase()}</p>
            <p className="font-sans-ui text-[12px] text-ivory/55 leading-relaxed mt-1">{c.desc}</p>
          </div>
          <Toggle on={!!prefs[c.key]} locked={c.locked} testid={`cookie-toggle-${c.key}`} onChange={() => onToggle(c.key)} />
        </li>
      ))}
    </ul>
  </motion.div>
);
